import { inject } from 'vue';
import { useStore } from 'vuex';

import { accountGtmEvents } from '@/gtm/account-gtm-events';
import { useMindboxAnalytics } from '@/useMindboxAnalytics';
import { removeCookieDeleteAccountRequested } from '@/utils/cookies/delete-account-cookie';

export const useLogout = () => {
  const store = useStore();
  const { removeCookie } = useMindboxAnalytics();
  const $persEvents = inject('$persEvents');

  const logoutAccount = async () => {
    removeCookie();
    removeCookieDeleteAccountRequested();

    await store.$apiBFF.logout();

    $persEvents.sendUserLogOutEvent();
    accountGtmEvents.onClickExit();
    location.assign('/');
  };

  return {
    logoutAccount,
  };
};
